<template>
	<div class="underwrite" @mouseenter="show(true)" @mouseleave="show(false)">
		<div class="button flex-center"><slot></slot> <i class="tf tf-tri-down"></i></div>
		
		<template v-if="type">
			<div v-if="typeList.length"  v-show="showMore" class="list" :style="moreListPosition">
				<div v-for="(item, i) in typeList" :key="i" class="item">
					<p @click="handle(type, item.id)">{{item.name}}{{item.type == 2 ? '（小额）' : ''}}</p>
				</div>
			</div>
		</template>
		
		<template v-else-if="company">
			<div v-if="typeList.length" v-show="showMore" class="list" :style="moreListPosition">
				<div v-for="(item, i) in typeList" :key="i" class="item">
					<p @click="handle(item.type_id, company)">{{item.type_name}}</p>
				</div>
			</div>
		</template>
		
		<div v-else v-show="showMore" class="list" :style="moreListPosition">
			<div v-for="(type, i) in typeList" :key="i" class="item" @mouseenter="getInsurance(type)">
				<p>{{type.type_name}}</p>
				
				<ul v-if="type.list && type.list.length" class="list">
					<li v-for="(item, j) in type.list" :key="j" class="item"><p @click="handle(type.type_id, item.id)">{{item.name}}{{item.type == 2 ? '（小额）' : ''}}</p></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			projectId: [String, Number],
			type: [String, Number],
			company: [String, Number]
		},
		
		data() {
			return {
				typeList: [],
				showMore: false,
				moreListPosition: {}
			}
		},
		
		mounted() {
			if (this.type) {
				this.request({
					url: '/bxgs/list',
					data: {
						type_id: this.type
					},
					success: data => {
						this.typeList = data;
					}
				});
			} else if (this.company) {
				this.request({
					url: '/bxgs_type/list',
					data: {
						bxgs_id: this.company
					},
					success: data => {
						this.typeList = data;
					}
				});
			} else {
				this.request({
					url: '/bx_type/list',
					success: data => {
						this.typeList = data;
					}
				});
			}
		},
		
		methods: {
			getInsurance(item) {
				if (item.list) return;
				this.request({
					url: '/bxgs/list',
					data: {
						type_id: item.type_id
					},
					success: data => {
						this.$set(item, 'list', data);
					}
				});
			},
			
			show(state) {
				if (state) {
					let right = $(this.$el).offset().left > $(window).width() / 2;
					this.moreListPosition = {
						left: right ? 'auto' : ($(this.$el).offset().left + 'px'),
						right: right ? ($(window).width() - $(this.$el).offset().left - $(this.$el).innerWidth() + 'px') : 'auto',
						top: $(this.$el).offset().top + $(this.$el).innerHeight() - window.scrollY + 'px',
						minWidth: $(this.$el).innerWidth() + 'px'
					}
					this.showMore = true;
				} else {
					this.showMore = false;
				}
			},
			
			handle(type, id) {
				// if (type == 3) {
				// 	this.$confirm({
				// 		text: '系统消息提醒',
				// 		message: '农民工保函由于各地费率不一致，请拨打电话：13758112094直接购买',
				// 		buttonName: '我知道了',
				// 		cancelButton: false
				// 	});
				// 	return;
				// }
				this.navigateTo('/transact/insurance/apply', {type, companyId: id, projectId: this.projectId || ''}, true);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.underwrite {
		display: inline-block;
		position: relative;
		box-sizing: border-box;
		height: 32px;
		padding: 0 10px;
		line-height: 32px;
		font-size: 14px;
		color: #fff;
		background: #1492FF;
		cursor: pointer;
		
		elder({
			height: 46px,
			line-height: 46px,
			font-size: 20px
		})
		
		&:hover {
			background: #117CD9;
		}
		
		.button {
			height: 100%;
			
			.tf {
				margin-left: .5em;
			}
		}
		
		.list {
			z-index: 99;
			position: absolute;
			left: 0;
			top: 0;
			padding: 4px 0;
			background: #fff;
			box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
			
			.item {
				&:hover > p{
					color: #1492FF;
					background: #F2F4F7;
				}
				
				p {
					padding: 8px 12px;
					line-height: 20px;
					font-size: 14px;
					white-space: nowrap;
					color: #333;
					
					elder({
						line-height: 34px,
						font-size: 24px,
					})
				}
			}
		}
		
		div.list {
			position: fixed;
			
			.item {
				position: relative;
				
				&:hover ul {
					display: block;
				}
				
				ul {
					display: none;
					left: 100%;
					top: 0;
				}
			}
		}
	}
</style>
